import type { FunctionComponent, HTMLProps, ReactNode } from 'react'
import React from 'react'

import classnames from 'classnames'

import styles from './ListItemBullet.module.scss'

export const ListItemBullet: FunctionComponent<Props> = ({
  children,
  className,
  ...rest
}) => {
  return (
    <li className={classnames(styles.listItemBullet, className)} {...rest}>
      <span className={styles.listItemBulletContent}>{children}</span>
    </li>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  className?: string
  children: ReactNode
} & HTMLProps<HTMLLIElement>
